<template>
    <div
        class="container"
        :class="{'school-center': curTheme}"
    >
        <PPTUploadDialog
        :visible.sync="$store.state.isPPTUploadRate"
        :rate="showProTxt"
        @close="closePPTStatus"
        @end="closePPTUpload"
        />
        <Top v-if="!curTheme" :isBack="isEdit" />
        <div class="tab-box" v-if="!curTheme">
            <el-radio-group
                    v-model="typeSelect"
                    size="medium">
                <el-radio-button v-if="isShow" label="我的课件" name="我的课件"></el-radio-button>
                <el-radio-button v-if="isShow" label="我的模版" name="我的模版"></el-radio-button>
                <el-radio-button label="公共模版" name="公共模版"></el-radio-button>
            </el-radio-group>
        </div>
        <div class="list-content">
            <div class="select-box">
                <Subject
                    v-if="isSubject"
                    :select.sync="subjectSelect"
                    :type.sync="typeSelect"
                    :typeIndex.sync="typeIndex"
                    :isTheme="curTheme"
                    @onPackState="onPackState"
                    @onSubjectOptions="onSubjectOptions"
                />

                <div class="right-box">
                    <Search
                        :value.sync="search"
                        @onSearch="onSearch"
                    />
                </div>
            </div>
            <div class="list-box" id="list-box">
                <AddTemplate
                    :auth="auth"
                    :uploadPPtName="uploadPPtName"
                    :showProTxt="showProTxt"
                    :showProBtn="showProBtn"
                    v-if="auth.add || auth.ppt"
                    @onNew="onNew"
                    @onPPT="onPPT"
                    @onEnd="closePPTUpload"
                />
                <template v-for="(item,index) in form">
                    <SubjectItem
                        :key="index"
                        :auth.sync="auth"
                        :data="item"
                        :typeSelect.sync="typeSelect"
                        v-bind="item"
                        @onOperation="onOperation"
                    />
                </template>
            </div>
        </div>
        <div class="pages">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="newPagination.currentPage"
                :page-size="parseInt(newPagination.pageSize)"
                :total="newPagination.total"
                @current-change="currentChange"
            >
            </el-pagination>
        </div>
        <EditName
            v-if="isEditName"
            :visible.sync="isEditName"
            :type.sync="typeSelect"
            :editNameData.sync="editNameData"
            @success="flashData"
        />
        <PackageStatus
            v-if="isPackageStatus"
            :visible.sync="isPackageStatus"
            :form.sync="packageItem"
            :rate.sync="packageRate"
            @success="successPackageStatus"
        />
        <IMShareCourse
            v-if="isShareCourse"
            :visible.sync="isShareCourse"
            v-bind="shareConfig"
        />
        <IMForm
                title="分类选择"
                v-if="isShowSubjectForm"
                :form="subjectTempForm"
                :visible.sync="isShowSubjectForm"
                width="30%"
                @success="onIMFormSubjectTemp"
                @onAttr="onChangeSubject"
        />
        <IMForm
                title="设为模版"
                v-if="isShowTempForm"
                :form="tempForm"
                :visible.sync="isShowTempForm"
                :defaultValue.sync="tempFormDefault"
                width="30%"
                @success="onIMFormSetTemp"
        />
        <IMForm
            title="课件排序"
            v-if="isOrder"
            :form="orderForm"
            :visible.sync="isOrder"
            :defaultValue.sync="editItem"
            width="30%"
            @success="onIMFormSetOrder"
        />
        <IMForm
            title="课件信息编辑"
            v-if="isEditInfo"
            :form="editInfoForm"
            :visible.sync="isEditInfo"
            :defaultValue.sync="editItem"
            width="500px"
            @success="onIMFormEditInfo"
            @onAttr="editInfoChange"
        />
        <Detail
            :id.sync="detailId"
            v-if="isDetail"
            :visible.sync="isDetail"
        />

        <el-dialog
          :title="dialog_practice.title"
          :visible.sync="dialog_practice.show"
          width="400px"
        >
          <el-row v-if="dialog_practice.type === 0" type="flex" class="dialog-footer" justify="center">
            <el-button size="small" type="primary" @click="showPracticeList">{{`选择${dialog_practice.text}练习`}}</el-button>
            <el-button size="small" type="primary" @click="showPracticeEdit">编辑制作</el-button>
          </el-row>
          <template v-else>
            <el-form size="small" label-width="94px">
              <el-form-item label="课件名称：">
                <p class="elps" style="line-height: 32px; width: 164px;" v-html="dialog_practice.data.name"></p>
              </el-form-item>

              <el-form-item label="练习名称：">
                <el-select v-model="dialog_practice.practiceId" placeholder="请选择练习名称" filterable autocomplete>
                  <el-option
                    v-for="(item, index) in dialog_practice.practiceOption"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <el-row type="flex" slot="footer" class="dialog-footer" justify="center">
              <el-button size="small" @click="cancelPracticeBind">取消绑定</el-button>
              <el-button size="small" type="primary" @click="getPracticeDetail()">预览练习</el-button>
              <el-button size="small" type="primary" @click="getPracticeEdit()">编辑练习</el-button>
            </el-row>
          </template>
        </el-dialog>

        <el-dialog
          v-if="dialog_practice_list.show"
          class="dialog-game dialog-sp1"
          :title="`${dialog_practice.data.name}绑定${dialog_practice.text}练习`"
          :visible.sync="dialog_practice_list.show"
          width="1000px"
        >
          <el-form
            :inline="true"
            size="small"
            :model="dialog_practice_list.form"
            @submit.native.prevent="getPracticeGameList()"
          >
            <el-form-item v-if="dialog_practice.text === '游戏'">
              <el-input v-model="dialog_practice_list.form.name" placeholder="请输入练习名称" clearable></el-input>
            </el-form-item>

            <template v-else>
              <el-form-item>
                <el-input v-model="dialog_practice_list.form.title" placeholder="请输入标题" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="dialog_practice_list.form.teacher_name" placeholder="请输入老师名称" clearable></el-input>
              </el-form-item>
            </template>

            <el-form-item>
              <el-button native-type="submit" :loading="dialog_practice_list.loading">搜 索</el-button>
            </el-form-item>
          </el-form>

          <el-table
            :data="dialog_practice_list.data"
            v-loading.lock="dialog_practice_list.loading"
            @selection-change="getPracticeGameSelect"
            row-key="id"
          >
            <el-table-column
              type="selection"
              width="54"
              reserve-selection
            >
            </el-table-column>

            <el-table-column
              v-for="(item, index) in dialog_practice_list.tableHead"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :formatter="item.formatter"
            >
            </el-table-column>

            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <el-link type="warning" @click="getPracticeDetail(scope.row)">预览</el-link>
              </template>
            </el-table-column>

            <div class="data-empty" slot="empty">
              <el-image :src="$images.empty"></el-image>
              <p>暂无数据</p>
            </div>
          </el-table>

          <el-pagination
            v-if="dialog_practice_list.data.length && dialog_practice_list.meta"
            background
            :page-size="10"
            :current-page="dialog_practice_list.meta.current_page"
            layout="prev, pager, next"
            :total="dialog_practice_list.meta.total"
            @current-change="getPracticeGameList"
          >
          </el-pagination>

          <div slot="footer" class="flex jc">
            <el-button size="small" @click="dialog_practice_list.show = false">取 消</el-button>
            <el-button size="small" type="primary" @click="getPracticeGameSubmit">确 定</el-button>
          </div>
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import common from '../common'
    import { Loading } from 'element-ui'
    import Top from './components/top'
    import Subject from './components/subject'
    import Search from './components/search'
    import AddTemplate from './components/addTemplate'
    import SubjectItem from './components/subjectItem'
    import LocalStorage from '../../utils/localStorageUtil'
    import EditName from './components/editName'
    import PPTUploadDialog from '../main/components/contents/components/pptUploadDialog'
    import Detail from './components/detail'
    import PackageStatus from './components/packageStatus'
    import {clickFile} from "../../utils/upload";
    import {getMessage} from "../../utils/messageEvent";
    import * as ResultServer from '../../api/result'
    import * as CommonServer from "../../api/common"
    import * as GlobalServer from '../../api/global'
    import * as CourseServer from '../../api/course'
    import {tempFields, orderFields, editInfoFields, subjectTempForm } from './fields'
    import Config from '@/config/app'
    import { getPracticeGame, getPracticeList, getCourseOnBind, getCourseOffBind, getCourseBindList } from '@/api/practice'
    let pptFn = null
    export default {
        name: "template-box",
        mixins: [common],
        components: {
            Top,
            Subject,
            Search,
            AddTemplate,
            SubjectItem,
            EditName,
            PPTUploadDialog,
            Detail,
            PackageStatus
        },
        computed: {
            ...mapGetters(['curTheme']),
            // 是否展示类型 如果是公共模版进来，隐藏我的课件 & 我的模版
            isShow(){
                let state = true
                if(this.$store.getters.isPlat) state = false
                return state
            },
            // 是否编辑，如果是编辑则有返回键
            isEdit(){
                let state = false
                try {
                    if(this.$route.query.isEdit){
                        state = true
                    }
                } catch (e) {
                  console.log('获取是否编辑==>', e)
                }
                return state
            },
            // 校区 校区开启和个人同时为true 才允许新增和编辑课件
            isAdd () {
                let state = false
                try {
                    if (`${this.$store.getters.curUserInfo.clients_course_make_status}` === '1' &&
                        `${this.$store.getters.curUserInfo.is_course_make}` === '1') {
                        state = true
                    }

                    if(this.$store.state.vipInfo.vip_type ==2 && this.$store.state.vipInfo.vip_expired == 0)state=(this.$store.state.userInfo.enable_courseware_use===1)?true:false;
                    if(this.$store.state.vipInfo.is_try_vip===1)state=true;
                } catch (e) {
                    console.log('获取失败==>', e)
                }
                return state
            },
            auth(){
             let obj = {}

             switch (this.typeSelect) {
                 case '我的课件':
                     obj = {
                         add: this.$store.state.permissions.class_mamage_add && this.isAdd,
                         edit: this.$store.state.permissions.class_mamage_edit && this.isAdd,
                         down: this.$store.state.permissions.class_mamage_down ,
                         delete: this.$store.state.permissions.class_mamage_delete,
                         ppt: this.$store.state.permissions['class_mamage_ppt'] && this.isAdd,
                     }
                     break;
                 case '我的模版':
                     obj = {
                         add: this.$store.state.permissions.meterial_template_my_add && this.isAdd,
                         edit: this.$store.state.permissions.meterial_template_my_edit && this.isAdd,
                         delete: this.$store.state.permissions.meterial_template_my_delete,
                         ppt: this.$store.state.permissions['meterial_template_my_ppt'] && this.isAdd,
                     }
                     break;
                 case '公共模版':
                     obj = {
                         add: this.$store.state.permissions.meterial_template_shop_add || isVip,
                         edit: this.$store.state.permissions.meterial_template_shop_edit || isVip,
                         delete: this.$store.state.permissions.meterial_template_shop_delete
                     }
                     break;
             }

             return obj;
            },
            // 是否是公共模版
            isTemplateShop () {
                let state = false
                try {
                    if (`${this.$route.query.is_template}` === 'true' && `${this.$route.query.is_shop}` === 'true') {
                        state = true
                    }
                }catch (e) {
                    console.log('获取是否公共模版==>', e)
                }
                return state
            },
            // 是不是公共平台
            is_shop(){
                let state = false
                switch (this.typeSelect) {
                    case '公共模版':
                        state = true
                        break;
                }
                return state
            }
        },
        watch: {
            subjectSelect(){
                this.flashData()
                this.initPPt()
            },
            typeSelect(){
                this.search = ''
                this.subjectSelect = ''
                this.flashData()
            },
            '$store.state.permissions': {
                handler (vl) {
                    if (Object.keys(vl).length > 0) {
                        this.flashData()
                    }
                },
                deep:true,
                immediate: true
            },
            '$store.getters.getShoolConfig.domain': {
                handler (newData, oldData) {
                    if(newData !== oldData) {
                        console.log(333)
                        this.initPPt()
                            this.$nextTick(() => {
                                try {
                                // 设置初始化配置
                                if (this.$route && this.$route.query && Object.keys(this.$route.query).length > 0 && !this.route.query.from) {
                                    setTimeout(() => {
                                        this.$store.dispatch('setInitConfig', {
                                            school_id: this.$store.state.initConfig.school_id || this.$route.query.school_id,
                                            ...this.$route.query
                                        })
                                    })
                                }
                                } catch (e) {
                                    console.log('设置domain==>', e)
                                }
                            })
                    }
                },
                deep:true,
                immediate: true
            }
        },
        beforeCreate () {
            if(this.$route && this.$route.query && this.$route.query.from !== 'schoolCenter'){
                // this.initSchool()
            }
        },
        created() {
            this.initSchool()
            // 创建之前先判断token存在否，如果不存在调转到中间授权
            if (this.$route && this.$route.query && this.$route.query.token) {
                LocalStorage.setToken(this.$route.query.token)
            }

            this.$nextTick(()=>{
                if(this.$route && this.$route.query && this.$route.query.from !== 'schoolCenter'){
                    this.initType()
                }
            })
        },
        mounted(){
            this.$nextTick(() => {
                window.parent.postMessage({ type: 'itGetIntConfig' }, '*')
                this.messageEvent()

                // 响应式列表
                setTimeout(() => {
                    this.calcList()
                }, 1000)
                window.onresize = ()=>{
                    this.calcList()
                }
            })
        },
        data() {
            return {
                showProBtn: false, // 按钮显示导入进度
                showProTxt: '导入进度：0%',
                uploadPPtName: 'ppt', // 当前导入的ppt名称
                addType: '', // add 新建课件 ppt导入ppt
                isShowSubjectForm: false,
                subjectOptions: [], // 学科选项
                subjectTempForm: [],
                // 下拉选择是否打开
                isSubject: this.$route && this.$route.query?this.$route.query.from !=='schoolCenter':false,
                isEditName: false, // 编辑名称
                editNameData: null, // 编辑内容

                package_status: '', // 当前选中的发布状态

                isPackageStatus: false, // 课包打包状态
                packageItem: null, // 包内容
                packageRate: 0, // 课件包打包进度
                runPackageFn: null, // 轮询打包状态

                isShareCourse: false, // 是否是分享
                shareConfig: {}, // 分享数据

                search: '',
                isLoading: false,
                typeSelect: '我的课件', // 我的课件-我的课件 我的模版-我的模版 公共模版-公共模版
                typeIndex: 0, // 默认选择第一个是课程分类，不允许添加，其余是课程分类
                subjectSelect: '', // 类型选中
                form: [
                    // {id: 1, title: '未命名-01', time: '2020-03-18 17:32',config: JSON.stringify({id:1,name:222})},
                    // {id: 2, title: '未命名-02', time: '2020-03-18 17:32'},
                ],
                pptFn: null, // ppt导入计时器
                newPagination: {
                    currentPage: 1,
                    pageSize: 14,
                    total: 1
                },

                isOrder: false, // 是否排序
                editItem: null, // 正在编辑的数据
                tempForm: this.$_.cloneDeepWith(tempFields),
                orderForm: this.$_.cloneDeepWith(orderFields),
                editInfoForm: this.$_.cloneDeepWith(editInfoFields),
                tempFormDefault: {
                    name: ''
                },
                isShowTempForm: false,
                isEditInfo: false, // 是否课件编辑

                isDetail: false, // 是否显示查看详情

                dialog_practice_list: {
                    show: false,
                    loading: false,
                    data: [],
                    form: {},
                    select: [],
                    tableHead: [],
                    gameHead: [
                      {
                        prop: 'name',
                        label: '练习名称'
                      },
                      // {
                      //   prop: 'name',
                      //   label: '关联课件名称'
                      // },
                      // {
                      //   prop: 'name',
                      //   label: '关联课件主题'
                      // },
                      {
                        prop: 'updated_at',
                        label: '更新时间'
                      },
                      {
                        prop: 'create_user.name',
                        label: '创建人'
                      },
                      {
                        prop: 'create_user.mobile',
                        label: '创建账号'
                      }
                    ],
                    userHead: [
                      {
                        prop: 'title',
                        label: '标题'
                      },
                      // {
                      //   prop: 'name',
                      //   label: '关联课件名称'
                      // },
                      // {
                      //   prop: 'name',
                      //   label: '关联课件主题'
                      // },
                      {
                        label: '评分方式',
                        formatter: row => {
                          let val = '--'

                          switch (row.score_type) {
                            case 0: val = '不评分'
                              break
                            case 10: val = '十分制'
                              break
                            case 100: val = '百分制'
                              break
                            case -1: val = '自定义'
                              break
                          }

                          return val
                        }
                      },
                      {
                        prop: 'users.name',
                        label: '教师名称',
                        formatter: row => row.users ? row.users.name : '--'
                      },
                      {
                        prop: 'created_at',
                        label: '创建时间'
                      }
                    ]
                },

                dialog_practice: { // 游戏练习制作
                    show: false,
                    type: '',
                    data: '',
                    text: '',
                    practiceId: 2,
                    practiceOption: [
                      {
                        label: '练习名称-1',
                        value: 1
                      },
                      {
                        label: '练习名称-2',
                        value: 2
                      }
                    ]
                }
            }
        },
        methods: {
            ...mapActions(['changeSelectSchoolId', 'setOtherToken']),
            successPackageStatus(){
                clearTimeout(this.runPackageFn)
            },
            calcList(){
                // 1.计算当前列表的总宽度
                // 2.计算每个item对应的宽度 新增｜元素
                // 3.重新计算每个元素的宽度 len.width/item.width 取整

                let div = document.getElementById('list-box')
                let divAdd = document.querySelector('#list-box .add-box')
                let items = document.querySelectorAll('#list-box .subject-box')
                if(items.length){
                    let allWidth = div.clientWidth
                    let itemWidth = 268
                    let newItemWidth = allWidth / Math.floor(allWidth / itemWidth)
                    console.log('总长度==>', allWidth, itemWidth, newItemWidth)
                    Array.from(items).map(v=>{
                        v.style.width = newItemWidth - 30 + 'px'
                    })
                    if(divAdd){
                        divAdd.style.width = newItemWidth - 30 + 'px'
                    }
                }

            },
            // initPPt(){
            // this.$store.state.isPPTUploadRate = false
            // const clientsId = `${this.$store.state.initConfig.school_id}`
            // const categoryId = `${this.subjectSelect}`
            // console.log('clientsId', clientsId)
            // console.log('categoryId', categoryId)
            // const ppt = JSON.parse(localStorage.getItem('pptToData_imedit'))
            // this.showProBtn = false
            // this.clearPollTime()
            // if (ppt && clientsId === `${ppt.clientsId}`) {
            //     if(!ppt.category_id || `${ppt.category_id}` === categoryId){
            //     this.showProBtn = true
            //     this.uploadPPtName = ppt.name
            //     this.poolPPtStatus(ppt)
            //     }
            // }
            // },
            initPPt(){
            this.$store.state.isPPTUploadRate = false
            const clientsId = `${this.$store.state.initConfig.school_id}`
            console.log('clientsId', clientsId)
            const ppt = JSON.parse(localStorage.getItem('pptToData_imedit'))
            this.showProBtn = false
            this.clearPollTime()
            if (ppt && clientsId === `${ppt.clientsId}`) {
                this.showProBtn = true
                this.uploadPPtName = ppt.name
                this.poolPPtStatus(ppt)
            }
            },
            initType(){
                this.typeSelect = this.isTemplateShop?'公共模版':'我的课件'
                this.flashData()
            },
            initSchool(){
                this.$store.dispatch('initSchool')
            },
            currentChange (page) {
                this.flashData(page)
            },
            // 监听 其他侧发过来的通知
            messageEvent () {
                getMessage(this.eventsList)
            },
            eventsList (e) {
                console.log('接收==>高级编辑器', e)
                let type = ''
                const { data } = e

                // 其他侧向web发出通知
                if (data.type && data.type.substr(0, 6) === 'center') {
                    // console.log('向it侧发出1：' + data.type + '消息==>', e)
                    type = data.type.substr(6)
                    // console.log('向it侧发出1-1：', type)
                    switch (type) {
                        case 'GetIntConfig':
                            this.setIntConfig(data.value)
                            break
                        case 'changeSelectSchoolId':
                            // console.log(window.location.href)
                            window.parent.postMessage({ type: 'itGetHistoryRoute', value: window.location.href }, '*')
                            break
                        case 'CloseUser':
                            this.$store.state.isCloseUser = data.value
                            break
                        default:
                    }
                }
            },
            setIntConfig(data){
                console.log('setIntConfig==>', data)
                if(data.school_id)this.$store.state.initConfig.school_id = data.school_id
                if (data.theme) this.$store.state.theme = data.theme
                if (data.token && data.client_id) {
                    this.setOtherToken(data)
                    this.initSchool()
                    this.initType()
                    this.$store.dispatch('setInitConfig', {
                        school_id: data.school_id
                    })
                    this.$store.state.token = data.token
                }

                this.isSubject = false
                this.isSubject = true

                this.$nextTick(() => {
                    window.parent.postMessage({ type: 'itGetCompleted' }, '*')

                    // 给body 设置 主题类名
                    if(data.theme){
                        document.body.classList.add(data.theme)
                    }
                })
            },
            // 课件学科筛选列表
            onSubjectOptions(data){
                this.subjectOptions = data
            },
            onPackState(state){
                this.package_status = state
                this.flashData()
            },
            async flashData(newPage){
                if (!this.$store.state.permissions) {
                    return false
                }
                let loadingInstance = Loading.service({ target: document.getElementById('list-box') });
                let page = this.newPagination.currentPage
                if (newPage) {
                    page = newPage
                }

                console.log(78789, this.$store.state.initConfig)
                let obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    page,
                    categoryId: this.subjectSelect,
                    per_page: this.newPagination.pageSize
                }
                if (this.search) {
                    obj.search = this.search
                }
                if (!this.isLoading) this.isLoading = true
                let res = null
                switch (this.typeSelect) {
                    case '我的课件':
                        obj['package_status'] = this.package_status
                        res = await ResultServer.getResultList(obj)
                        this.form = res.items.map(v=>{
                            return {
                                ...v,
                                url: v.cover,
                                subTitle: v.title,
                                time: v.updated_at
                            }
                        })
                        break;
                    case '我的模版':
                        obj.sort = 'template'
                        res = await CommonServer.default.getResourceList(obj)
                        this.form = res.items.map(v=>{
                            return {
                                ...v,
                                url: v.cover,
                                subTitle: v.title,
                                time: v.updated_at
                            }
                        })
                        break;
                    case '公共模版':
                        obj.sort = 'template'
                        obj.is_online = 1
                        res = await CommonServer.default.getResourceShopList(obj)
                        this.form = res.items.map(v=>{
                            return {
                                ...v,
                                url: v.cover,
                                subTitle: v.title,
                                time: v.updated_at
                            }
                        })
                        break;
                    default:
                        console.log('flashData==>',res)
                }
                if(res && res.meta){
                    this.newPagination.currentPage = res.meta.current_page
                    this.newPagination.per_page = res.meta.per_page
                    this.newPagination.total = res.meta.total

                    this.$nextTick(() => {
                        this.calcList()
                    })
                }

                setTimeout(()=>{
                    loadingInstance.close();
                })
            },
            onSearch(value){
                this.search = value
                console.log('搜索==>', value)
                this.flashData()
            },
            // 判断是否选中了目录
            isHasCategory(){
                let state = true
                switch (this.typeSelect) {
                    case '我的课件': {
                        if(this.subjectSelect <= 0){
                            // this.$message.error('请先选择分类')
                            const form = this.$_.cloneDeepWith(subjectTempForm)
                            const subjectIndex = this.$utils.getIndexByAttr({attr: 'subject_id', data: form})
                            form[subjectIndex].options = this.subjectOptions.map(v=>{
                                return {
                                    key: `${v.id}`,
                                    value: v.name
                                }
                            })
                            this.subjectTempForm = form
                            this.isShowSubjectForm = true
                            return false
                        }
                        break
                    }
                    case '我的模版': {
                        // if(!this.subjectSelect){
                        //     this.$message.error('请至少选择一级分类')
                        //     return false
                        // }
                        break
                    }
                }
                return state
            },
            // 新建
            onNew(category_id){
                this.addType = 'add'
                if(!category_id && !this.isHasCategory()){
                    return false
                }
                let obj = {
                    school_id: this.$store.state.initConfig.school_id || this.$route.query.school_id,
                    category_id: this.subjectSelect || 0
                }
                switch (this.typeSelect) {
                    case '我的课件':
                        obj = {
                            school_id: this.$store.state.initConfig.school_id || this.$route.query.school_id,
                            category_id: category_id || this.subjectSelect || 0
                        }
                        break;
                    case '我的模版':
                        obj.is_template = true
                        break;
                    case '公共模版':
                        obj.is_template = true
                        obj.is_shop = true
                        break;
                }
                // this.$RouteUtil.main(obj)
                // 打开一个新窗体
                let str = ''
                for(let item in obj){
                    str+= `&${item}=${obj[item]}`
                }
                window.open(`${window.location.origin}/main?${str}`)
            },
            // 导入PPT
            onPPT(category_id){
                this.addType = 'ppt'
                if(!category_id && !this.isHasCategory()){
                    return false
                }
                switch (this.typeSelect) {
                    case '我的课件':
                        // 1.导入ppt
                        // 2.组装数据新建我的课件
                        this.importPPTGo({type: '我的课件', category_id})
                        break;
                    case '我的模版':
                        // 1.导入ppt
                        // 2.组装数据新建我的模版
                        this.importPPTGo({type: '我的模版'})
                        break;
                    case '公共模版':
                        // 1.导入ppt
                        // 2.组装数据新建公共模版
                        this.importPPTGo({type: '公共模版'})
                        break;
                }
            },
            // 关闭进度弹窗
            closePPTStatus () {
            this.$store.state.isPPTUploadRate = false
            this.showProBtn = true
            },
            getConfigData({type, data, id, name, category_id, node_type}){
                const ppt = JSON.parse(localStorage.getItem('pptToData_imedit'))
                const storageId = ppt?ppt.category_id:null
                let obj = {
                    id,
                    clientsId: this.$store.state.initConfig.school_id,
                    category_id: storageId || category_id || this.subjectSelect || 0,
                    name: `PPT【${name}】`,
                    title: `PPT【${name}】`,
                    type: 'online',
                    cover: this.$images.default,
                    [node_type]:{ //attributes actions
                        h5_original: [],
                        h5_remote: {...data, urlMap: []},
                        cocos_original: [],
                        cocos_remote: this.$cocosUtils.cocosConfig({data})
                    }
                }

                // 模版创建
                if(type === '我的模版'){
                    obj.sort = 'template'
                    obj.categoryId = this.subjectSelect
                    obj.cover = this.$images.default
                    obj.attributes.cover = this.$images.default
                }
                console.log(node_type, obj)
                return obj
            },
            async importPPTGo({type, category_id}){
                console.log('importPPTGo==>', type)
                this.showProTxt = '导入进度：0%'
                clickFile({
                    isPPT: true,
                    isPlat: type === '公共模版'? true : false,
                    accept: '.pptx',
                    backType: 'object',
                    isLoading: true,
                    callback: async (res) => {
                        this.uploadPPtName = res.name
                        // 先创建一个空的课件/模版 并将id传给服务器
                        const data = {
                            blocksForm: [],
                            blocksSelected: '',
                            lessonSelected: '',
                            scenes_stage_id: '',
                            scenes_state_shop: false
                        }

                        // 1.获取当前默认导航 如果导航没数据，自己创建一个【默认导航】
                        // 2.默认选中导航第一个目录 且选中第一个菜单
                        const res1 = await CommonServer.default.getResourceList({
                            clientsId:this.$store.state.initConfig.school_id,
                            sort:'scenes_stage'
                        })

                        if(res1.items[0]) {
                            console.log(res1)
                            data.scenes_stage_id = res1.items[0].id
                            data.scenes_state_shop = false
                            const options = res1.items[0].attributes.options
                            data.blocksForm = options.map((v, i) => {
                                let obj = {
                                    id: `${i}`,
                                    url: '',
                                    name: v,
                                    children: []
                                }
                                if (typeof v === 'object') {
                                    obj = {...obj, ...v}
                                }
                                // 兼容旧数据导航
                                if (!obj.unique) {
                                    obj.unique = Math.random() + i
                                }
                                return obj
                            })
                            // 如果菜单中存在重复unique,重新计算
                            data.blocksForm = this.$utils.calcNavIsUnique({data: data.blocksForm})
                        } else {
                            // 导航不存在 给一个默认
                            data.blocksForm = [{
                                id: '0',
                                url: '',
                                name: '默认导航',
                                children: [],
                                unique: Math.random() + Math.random()
                            }]
                        }
                        // 获取当前第一个目录
                        const firstMenuUnique = this.$utils.getFirstMenu({data: data.blocksForm, unique: ''})
                        data.blocksSelected = firstMenuUnique
                        let result1 = null
                        let obj = this.getConfigData({type, data, name: res.name, category_id, node_type:'actions'})
                        if(type === '我的模版'){
                            result1 = await CommonServer.default.addResource(obj)
                        } else {
                            result1 = await ResultServer.addResult(obj)
                        }

                        // source 1 我的课件 2 我的模板 3 公共模板
                        let source = '1'
                        if(`${this.$route.query.is_template}` === 'true'){
                            source = '2'
                            if(`${this.$route.query.is_shop}` === 'true') source = '3'
                        }

                        let id = ''
                        if (result1.status_code === 200) {
                            id = result1.data.id
                            console.log('插入课件/模版成功==>', result1)
                        } else {
                            this.$message.error('插入课件/模版失败')
                            return false
                        }

                        console.log('上传ppt回调==>', res)
                        res.loadingInstance.close()
                        this.$store.state.isPPTUploadRate = true
                        this.$store.state.isPPTUploading = true
                        this.$store.state.curPPTRate = 0
                        // 1.PPT导入成功后 拿到后端返回的ppt压缩路径和页数 开始插入菜单
                        // 2.实时请求后端状态接口
                        const result = await GlobalServer.importPPT({
                            clientsId: this.$store.state.initConfig.school_id,
                            name: res.name,
                            url: res.url.split('.com/')[1],
                            etag: this.$utils.getMd5(res.url),
                            result_id: id,
                            source
                        })
                        this.$store.state.curPPTRate = 0
                        if(result && result.status_code === 200){
                        // 轮询ppt解码状态
                        const pptToData_imedit = {
                        type,
                        clientsId: this.$store.state.initConfig.school_id,
                        category_id,
                        name: res.name,
                        url: res.url,
                        id: result.data.id,
                        ppt_id: result1.data.id
                        }
                        localStorage.setItem('pptToData_imedit', JSON.stringify(pptToData_imedit))
                        this.poolPPtStatus(pptToData_imedit)
                        // type, res, id, ppt_id, category_id
                        }
                    }
                })
            },
            // 轮询ppt解码状态
            poolPPtStatus(val){
                // console.log('poolPPtStatus', id, ppt_id)
              const func = async()=>{
                const status = await GlobalServer.getPPTStatus({id: val.id})
                const progress = status.data.attributes.progress
                this.$store.state.curPPTRate = progress
                this.showProTxt = `导入进度：${this.$store.state.curPPTRate}%`
                console.log('ppt上传后台进度', progress)
                if(`${status.data.attributes.status}` === '3') {
                    this.$store.state.isPPTUploadRate = false
                    this.deleteDataOne(val.ppt_id, 'error', 'PPT转换失败，已删除导入数据!')
                    localStorage.removeItem('pptToData_imedit')
                    this.showProBtn = false
                    this.clearPollTime()
                    return
                }
                if(progress >= 100) {
                    this.showProTxt = '更新数据中...'
                    // if(this.$store.state.isPPTUploadRate) this.$store.state.isPPTUploadRate = false
                    // 解码成功
                    // 前端手动设置ppt状态 设置为已插入页面中
                    // 将ppt内容约定的格式，新建课件/新建模版
                    const opted = await ResultServer.updatePPTStatus({
                        clientsId: this.$store.state.initConfig.school_id,
                        resources_id: status.data.id,
                        status: 2
                    })
                    if(opted && opted.status_code === 200) {
                        switch (val.type) {
                            case '我的课件':
                                console.log('ppt转课件==>')
                                this.ppt2menu({val, pptConfig: status.data.attributes, category_id:val.category_id})
                                break;
                            case '我的模版':
                                console.log('ppt转我的模版==>')
                                this.ppt2menu({val, pptConfig: status.data.attributes})
                                break;
                            case '公共模版':
                                console.log('ppt转公共模版==>')
                                break;
                        }
                    }
                    // 如果导航存在，则数据装在到该导航第一个菜单中
                    // 否则自动生成一个默认导航，将数据装进第一个导航中
                } else {
                this.clearPollTime()
                    pptFn = window.setTimeout(() => {
                        func()
                    }, 2000)
                    this.$once('hook:beforeDestroy', () => {
                        this.clearPollTime()
                  })
                }
            }
            func && func()
            },
            // 清除数据轮询
            clearPollTime () {
            window.clearTimeout(pptFn)
            pptFn = null
            },
            // ppt转成数据新建课件 //type, pptConfig, id, name, ppt_id, category_id
            async ppt2menu({val, pptConfig, category_id}){
                const data = {
                    blocksForm: [],
                    blocksSelected: '',
                    lessonSelected: '',
                    scenes_stage_id: '',
                    scenes_state_shop: false
                }

                // TODO 1.获取当前默认导航 如果导航没数据，自己创建一个【默认导航】
                // 2.默认选中导航第一个目录 且选中第一个菜单
                const res = await CommonServer.default.getResourceList({
                    clientsId:this.$store.state.initConfig.school_id,
                    sort:'scenes_stage'
                })
                if(res.items[0]) {
                    data.scenes_stage_id = res.items[0].id
                    data.scenes_state_shop = false
                    const options = res.items[0].attributes.options
                    data.blocksForm = options.map((v, i) => {
                        let obj = {
                            id: `${i}`,
                            url: '',
                            name: v,
                            children: []
                        }
                        if (typeof v === 'object') {
                            obj = {...obj, ...v}
                        }
                        // 兼容旧数据导航
                        if (!obj.unique) {
                            obj.unique = Math.random() + i
                        }
                        return obj
                    })

                    // 如果菜单中存在重复unique,重新计算
                    data.blocksForm = this.$utils.calcNavIsUnique({data: data.blocksForm})
                } else {
                    // 导航不存在 给一个默认
                    data.blocksForm = [{
                        id: '0',
                        url: '',
                        name: '默认导航',
                        children: [],
                        unique: Math.random() + Math.random()
                    }]
                }

                // 获取当前第一个目录
                const firstMenuUnique = this.$utils.getFirstMenu({data: data.blocksForm, unique: ''})
                data.blocksSelected = firstMenuUnique

                // 获取当前选中的菜单目录节点
                const curSelectedNode = this.$utils.curSelectedNode({data: data.blocksForm, unique: firstMenuUnique})

                // 将PPT转的数据装进当前菜单目录中
                // TODO 获取ppt转码后的字段
                // [{type:"html",config:{url:"xxx/Slide1.html"}}]
                const temp = {
                    type: 'html',
                    theme: {background:{url:'', type: 'image'}},
                    config: {
                        cocos_dir: '',
                        static_id: '',
                        url:'',
                        cocosGameBackgroundImage: ''
                    }
                }
                const newArr = new Array(pptConfig.limit).fill('')
                const h5_remote = pptConfig.h5_dir
                const arr = newArr.map((v, i)=>{
                    let obj = this.$utils.getRandomByObj(this.$_.cloneDeepWith(temp))
                    let name = `Slide${i + 1}`
                    obj.config.cocos_dir = pptConfig.cocos_dir
                    obj.config.static_id = pptConfig.id
                    obj.config.url = `${h5_remote}/${name}.html`
                    obj.config.cocosGameBackgroundImage = `${h5_remote}/data/Thumbnails/${name}.png`
                    return obj
                })
                // 设置默认选中菜单
                data.lessonSelected = arr[0].unique
                curSelectedNode.children = arr

                let result = null
                let obj = this.getConfigData({type:val.type, data, id:val.ppt_id, name:val.name, category_id, node_type: 'attributes'})
                // 更新数据
                if(val.type === '我的模版'){
                    result = await CommonServer.default.updateResource(obj)
                } else {
                    result = await ResultServer.updateResult(obj)
                }
                console.log('添加成功==>去刷新', result, data, obj, firstMenuUnique, curSelectedNode)
                this.showProBtn = false
                if (this.$store.state.isPPTUploadRate) this.$store.state.isPPTUploadRate = false
                localStorage.removeItem('pptToData_imedit')
                if (result.status_code === 200) {
                    this.$message.success('PPT导入成功')
                    this.flashData()
                } else {
                    this.deleteDataOne({ppt_id:val.ppt_id, type: 'error', message: 'PPT导入失败，已删除导入数据!'})
                }

            },
            // 结束ppt导入
            closePPTUpload () {
            const pptToData_imedit = JSON.parse(localStorage.getItem('pptToData_imedit'))
            this.$confirm('此操作将<span style="color:red;font-weight: 600;">结束PPT导入</span>, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                    instance.confirmButtonLoading = true
                    this.showProBtn = false
                    this.$store.state.isPPTUploadRate = false
                    localStorage.removeItem('pptToData_imedit')
                    this.isPPTing = []
                    this.clearPollTime()
                    ResultServer.deleteResult({ id: pptToData_imedit.ppt_id, clientsId: this.$store.state.initConfig.school_id })
                    .then(res => {
                        if (res.status_code === 200) {
                        this.$message({
                            type: 'error',
                            message: 'PPT导入失败，已删除导入数据!'
                        })
                        this.flashData()
                        }
                        instance.confirmButtonLoading = false
                    }).catch(err => {
                        console.log(err)
                        instance.confirmButtonLoading = false
                    })
                    done()
                } else {
                    done()
                }
                }
            }).then(() => {
                console.log('已关闭')
            }).catch(() => {
                console.log('已取消')
            })
            },
            // 复制一份
            async onOperation({ type, data, datas }){
                console.log('具体动作==>', type, data)
                switch (type) {
                    case 'detail':
                        this.detail(data)
                        break
                    case 'copyConfig':
                        this.copyConfig(data)
                        break
                    case 'edit':
                        this.edit(data)
                        break
                    case 'preview':
                        this.preview(data)
                        break
                    case 'down':
                        this.down(data)
                        break
                    case 'del':
                        this.del(data)
                        break
                    case 'editName':
                        this.editName(datas)
                        break
                    case 'share':
                        this.share(data)
                        break
                    case 'update':
                        console.log('更新==>')
                        // 更新(发布) 课件
                        this.updateCourse(data)
                        break
                    case 'order':
                        console.log('排序==>')
                        // 排序
                        this.isOrder = true
                        this.editItem = data
                        if (this.editItem.order && typeof this.editItem.order === 'string') {
                            this.editItem.order = parseInt(this.editItem.order)
                        }
                        break
                    case 'copy':
                        console.log('复制==>')
                        this.copyRow({data})
                        break
                    case 'template':
                        console.log('设为模版')
                        this.tempFormDefault.name = data.name + '【复制】'
                        this.editItem = data
                        this.setTempCategory(this.editItem)
                        break
                    case 'edit-info': {
                        console.log('课件信息编辑')
                        this.editItem = datas
                        console.log("editItem",this.editItem);

                        // 如果存在分类目录则，设置初始值
                        if (this.editItem.category_id) {
                            // 获取目录中的所有父级id

                            // 1.获取整个树节点
                            // 2.通过当前节点找到所有父级节点
                            const res = await CourseServer.getCourseRuleList({
                                clientsId: this.$store.state.initConfig.school_id,
                                parentId: 0
                            })

                            // 如果目录为数组 则获取数组中的目录id
                            let category_id = this.editItem.category_id
                            if (Array.isArray(category_id)) category_id = category_id[category_id.length - 1]

                            const arr = this.$utils.getParentNode(res.data, category_id)

                            const parentId = `${arr.shift()['id']}`
                            this.setCatalogOptions({parentId})
                            this.editItem['category_id_parent'] = parentId
                            if (arr && arr.length > 0) this.editItem['category_id'] = arr.map(v => `${v.id}`)
                        }

                        const func = () => {
                            this.isEditInfo = true
                        }
                        // 设置分类列表选项
                        this.setCatalogList(func)
                        break
                    }
                    case 'practice-game': {
                        this.dialog_practice.type = data.is_bind_exercise_game
                        this.dialog_practice.data = data
                        this.dialog_practice.text = '游戏'
                        this.showPractice()
                        break
                    }
                    case 'practice-custom': {
                        this.dialog_practice.type = data.is_bind_exercise_customize
                        this.dialog_practice.data = data
                        this.dialog_practice.text = '自定义'
                        this.showPractice()
                        break
                    }
                    case 'course':
                        window.top.postMessage({
                            type: 'itShowCourseScreen',
                            value: datas
                        }, '*')
                        break
                }
            },
            // 查看详情
            detail(data){
                // 查看详情
                this.isDetail = true
                this.detailId = data.id
            },
            // 设置分类列表
            async setCatalogOptions ({ parentId }) {
                const res = await CourseServer.getCourseRuleList({
                    clientsId: this.$store.state.initConfig.school_id,
                    parentId
                })
                const catalogIdIndex = this.$utils.getIndexByAttr({
                    attr: 'category_id',
                    data: this.editInfoForm
                })
                this.editInfoForm[catalogIdIndex].options = this.$utils.getNewChilrens(res.data.childrens)
            },
            // 设置编辑信息分类筛选项
            setCatalogList (fn) {
                this.editInfoForm.map(async v => {
                    switch (v.attr) {
                        case 'category_id_parent': {
                            // 获取分类列表筛选项
                            const res = await CourseServer['getCourseTypeList'](
                                {
                                    clientsId: this.$store.state.initConfig.school_id,
                                    per_page: 1000
                                }
                            )
                            console.log(res)
                            v.options = res.items.map(v => {
                                return {
                                    key: `${v.id}`,
                                    value: v.name
                                }
                            })
                            break
                        }
                    }
                })
                const fn2 = setTimeout(() => {
                    fn && fn()
                    clearTimeout(fn2)
                }, 500)
            },
            // 课件编辑
            async onIMFormEditInfo (data) {
                const config = this.$utils.getObjByArr({ data })
                const { id } = this.editItem
                const res = await ResultServer.getResultDetail({
                    id,
                    clientsId: this.$store.state.initConfig.school_id
                })
                let result
                if (res.status_code === 200) {
                    //const { h5_original, h5_remote, cocos_original, cocos_remote } = res.data.attr_last
                    result = await ResultServer.updateResult({
                        ...this.editItem,
                        id: this.editItem.id,
                        clientsId: this.$store.state.initConfig.school_id,
                        category_id: parseInt(config.category_id[config.category_id.length - 1]),
                        name: config.name,
                        title: config.title,
                        cover: config.cover,
                        knowledge: config.knowledge,
                        desc: config.desc,
                        type: this.editItem.type,
                        /*attributes: {
                            h5_original,
                            h5_remote,
                            cocos_original,
                            cocos_remote
                        }*/
                    })
                }
                if (result.status_code === 200) {
                    this.flashData()
                    this.$message.success('编辑成功')
                } else {
                    this.$message.error('编辑失败')
                }
            },
            // 分类列表改变回调
            async editInfoChange (item) {
                // 获取目录列表树
                console.log('editInfoChange==>', item)
                switch (item.attr) {
                    case 'category_id_parent': {
                        const category_id_parent_index = this.$utils.getIndexByAttr({
                            attr: 'category_id_parent',
                            data: this.editInfoForm
                        })
                        const parentId = this.editInfoForm[category_id_parent_index].value
                        console.log('设置分类列表选项77==>', parentId)
                        this.setCatalogOptions({ parentId })
                        break
                    }
                }
            },
            // 更新课件
            async updateCourse (data) {
                const { id } = data
                // 根据课件id获取课件详情
                // 将h5_remote转成cocos_remote
                const config_type = 'web_edit'
                const detail = await ResultServer.getResultDetail({
                    id,
                    clientsId: this.$store.state.initConfig.school_id,
                    config_type
                })
                let cocos_remote = []
                try {
                    cocos_remote = this.$cocosUtils.cocosConfig({data: detail.data.attr_last.h5_remote})
                } catch (e) {
                    console.log('获取cocos_remote失败==>', e)
                }

                const res = await ResultServer.sendPacket({
                    id,
                    clientsId: this.$store.state.initConfig.school_id,
                    cocos_remote
                })
                if (res && res.data && res.data.attr_id_last) {
                    this.flashData()
                    this.$message.success('更新成功')
                }
                console.log(res)
            },

            // 设置排序
            async onIMFormSetOrder (data) {
                const config = this.$utils.getObjByArr({ data })
                const { id } = this.editItem
                const res = await ResultServer.updateResultOrder({
                    id,
                    clientsId: this.$store.state.initConfig.school_id,
                    order: parseInt(config.order)
                })
                if (res.status_code === 200) {
                    this.flashData()
                    this.$message.success('排序设置成功')
                } else {
                    this.$message.error('排序编辑失败')
                }
            },
            onIMFormSubjectTemp(data){
                // 分类选中回调
                console.log('onIMFormSubjectTemp==>', data)
                const categoryIndex = this.$utils.getIndexByAttr({attr: 'category_id', data: this.subjectTempForm})
                const arr = this.subjectTempForm[categoryIndex].value
                const category_id = arr.pop()
                if(category_id){
                    // 去新建课件 或 导入ppt
                    switch (this.addType) {
                        case 'add':{
                            // 新建课件
                            this.onNew(category_id)
                            break;
                        }
                        case 'ppt':{
                            // 导入ppt
                            this.onPPT(category_id)
                            break;
                        }
                    }

                }
            },
            setOptions({data}){
                return this.$utils.oldTree2NewTree({data, oldKeys: ['childrens', 'id', 'name'], newKeys: ['children', 'key', 'value']})
            },
            async onChangeSubject(obj){
                switch (obj.attr) {
                    case 'subject_id': {
                        const subjectIndex = this.$utils.getIndexByAttr({attr: 'subject_id', data: this.subjectTempForm})
                        const id = this.subjectTempForm[subjectIndex].value
                        const res = await CourseServer.getCourseRuleList({
                            clientsId: this.$store.state.initConfig.school_id,
                            parentId: id
                        })
                        console.log('我的课件-2==>', res)
                        let newData = this.setOptions({data:res.data.childrens})
                        const categoryIndex = this.$utils.getIndexByAttr({attr: 'category_id', data: this.subjectTempForm})
                        this.subjectTempForm[categoryIndex].options = newData
                        // 获取分类列表
                        break;
                    }
                }
            },
            async onIMFormSetTemp (data) {
                // 设置模版 = 复制一份课件到模版
                // 判断这个课件属于校区或公共，clientId
                const config = this.$utils.getObjByArr({ data })
                console.log('编辑模版==>', config, this.editItem)

                // 获取课件详情
                const res = await ResultServer.getResultDetail({
                    id: this.editItem.id,
                    clientsId: this.$store.state.initConfig.school_id
                })
                let categoryId = config.categoryId
                if (Array.isArray(categoryId)) {
                    categoryId = categoryId[categoryId.length - 1]
                }
                const obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: 'template',
                    categoryId,
                    name: config.name,
                    attributes: {
                        cover: res.data.cover,
                        h5_original: res.data.attr_last.h5_original,
                        h5_remote: res.data.attr_last.h5_remote,
                        cocos_original: [],
                        cocos_remote: []
                    }
                }
                console.log('参数==>', res.data, obj)
                const addResource = this.editItem.clients_id ? 'addResource' : 'addResourceShop'
                const result = await CommonServer.default[addResource](obj)
                console.log('result==>', result)
                if (result.status_code === 200) {
                    this.$message.success('模版设置成功')
                } else if (`${result.status_code}` === '422') {
                    this.$message.error(result.errors.name.toString())
                } else {
                    this.$message.error('模版设置失败')
                }
            },
            // 复制行
            copyRow ({ data }) {
                ResultServer.copyResult({
                    src_id: data.id,
                    categoryId: data.category_id,
                    clientsId: this.$store.state.initConfig.school_id
                })
                    .then(res => {
                        if (res.status_code === 200) {
                            this.$message({
                                type: 'success',
                                message: '复制成功!'
                            })
                            this.flashData()
                        }
                    })
            },
            // 模版设置目录数据
            async setTempCategory (data) {
                let res = null
                const obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: 'template'
                }
                if (data.clients_id) {
                    // 校区
                    res = await CommonServer.default.getResourceCategoryTree(obj)
                } else {
                    // 公共
                    res = await CommonServer.default.getResourceCategoryShopTree(obj)
                }
                const categoryIdIndex = this.$utils.getIndexByAttr({ attr: 'categoryId', data: this.tempForm })
                this.tempForm[categoryIdIndex].options = this.$utils.FormatData(res.data)

                this.isShowTempForm = true
            },
            // 复制配置 到本地存储
            async copyConfig(data){
                console.log('复制内容==>', data)
                let newData = null
                let res = null
                let obj = {id:data.id,clientsId: this.$store.state.initConfig.school_id}
                switch (this.typeSelect) {
                    case '我的课件':
                        res = await ResultServer.getResultDetail(obj)
                        newData = res.data.attr_last
                        break;
                    case '我的模版':
                        res = await CommonServer.default.getResourceDetail(obj)
                        newData = res.data.attributes
                        break;
                    case '公共模版':
                        res = await CommonServer.default.getResourceShopDetail(obj)
                        newData = res.data.attributes
                        break;
                }
                console.log('res==>', res)
                LocalStorage.setConfig(JSON.stringify({title: data.name,config: newData, schoolInfo: this.$store.getters.getShoolConfig}))
                this.$message.success('复制成功')
            },
            edit(item){
                console.log('item==>', item)
                let obj = {
                    id:item.id,
                    school_id: this.$store.state.initConfig.school_id || this.$route.query.school_id,
                    category_id: item.category_id,
                    is_shop: this.is_shop
                }
                switch (this.typeSelect) {
                    case '我的课件':
                        obj = {
                            school_id: this.$store.state.initConfig.school_id || this.$route.query.school_id,
                            category_id: item.category_id,
                            id:item.id
                        }
                        break;
                    case '我的模版':
                        obj.is_template = true
                        break;
                    case '公共模版':
                        obj.is_template = true
                        obj.is_shop = true
                        break;
                }
                // this.$RouteUtil.main(obj)
                // 打开一个新窗体
                let str = ''
                for(let item in obj){
                    str+= `&${item}=${obj[item]}`
                }
                window.open(`${window.location.origin}/main?${str}`)
            },
            preview(item){
                console.log('item==>', item)
                let obj = {
                    ...this.$route.query,
                    id:item.id,
                    school_id: this.$store.state.initConfig.school_id || this.$route.query.school_id,
                    category_id: item.category_id,
                    backType: 'template',
                    isEdit: true,
                    is_shop: this.is_shop
                }
                switch (this.typeSelect) {
                    case '我的课件':
                        obj.is_template = false
                        break;
                    case '我的模版':
                        obj.is_template = true
                        break;
                    case '公共模版':
                        obj.is_template = true
                        obj.is_shop = true
                        break;
                }
                // this.$RouteUtil.main(obj)
                // 打开一个新窗体
                let str = ''
                for(let item in obj){
                    str+= `&${item}=${obj[item]}`
                }
                window.open(`${window.location.origin}/preview?${str}&t=1`)
            },
            async down(item){
                console.log('down==>', item)
                
                const res = await ResultServer.getCombinePack({
                    resultId: item.id,
                    clientsId: this.$store.state.initConfig.school_id
                })
               
                if(res && res.status_code === 200) {
                    // 1.课包已经是最新的，直接下载
                    window.open(res.data)
                } else if (res && res.status_code === 407){
                  // 1.课包打包弹窗
                  this.isPackageStatus = true
                  this.packageItem = item
                  this.getPackageProgress(item)
                } else {
                    this.$message.warning(res && res.message)
                }
            },
            // 获取课件包打包进度
            async getPackageProgress(item){
                console.log('getPackageProgress==>', item)
                const func = async callback => {
                    const res = await ResultServer.getCombinePackStatus(({
                        resultId: item.id,
                        clientsId: this.$store.state.initConfig.school_id
                    }))
                    if(res && res.status_code === 200){
                        callback({
                            ...res.data
                        })
                    } else {
                        callback(false)
                    }
                }
                const callbackFunc = async res => {
                    if(!res){
                        // 请求失败
                    }else{
                        const { status, progress, message } = res
                        switch (status) {
                            case 'failure':
                                // 获取失败
                                this.$message.error(message)
                                break
                            case 'success': {
                                // 去下载
                                const result = await ResultServer.getCombinePack({
                                    resultId: item.id,
                                    clientsId: this.$store.state.initConfig.school_id
                                })
                                this.isPackageStatus = false
                                this.packageItem = null
                                window.open(result.data)
                                break
                            }
                            case 'run': {
                                // 正在打包-有打包进度
                                this.packageRate = progress
                                this.runPackageFn = setTimeout(() => {
                                    func(callbackFunc)
                                    clearTimeout(this.runPackageFn)
                                }, 1000)
                                break
                            }
                        }

                    }
                }
                func(callbackFunc)
            },
            // 刪除数据
            deleteDataOne (id, type, message) {
            ResultServer.deleteResult({ id, clientsId: this.$store.state.initConfig.school_id })
                .then(res => {
                if (res.status_code === 200) {
                    this.$message({
                    type,
                    message
                    })
                    this.flashData()
                }
                }).catch(err=>{
                    console.error(err)
                })
            },           
            del(data){
                this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    let res = null
                    let obj = {
                        id: data.id,
                        clientsId: this.$store.state.initConfig.school_id
                    }
                    switch (this.typeSelect) {
                        case '我的课件':
                            res = await ResultServer.deleteResult(obj)
                            break;
                        case '我的模版':
                            res = await CommonServer.default.deleteResource(obj)
                            break;
                        case '公共模版':
                            res = await CommonServer.default.deleteResourceShop(obj)
                            break;
                    }
                    if (`${res.status_code}` === '200') {
                        this.$message.success('删除成功')
                        this.flashData()
                    }
                }).catch(() => {
                    console.log('删除失败')
                });
            },
            editName(data){
                console.log('修改名称==>', data)
                this.isEditName = true
                this.editNameData = data
            },
            share(data){
                console.log('分享==>', data)
                // TODO 设置密码
                this.shareConfig = {
                    id: data.id,
                    name: data.name,
                    password: '123456',
                    link: 'https://baidu.com',
                }
                this.isShareCourse = true
            },

            async showPractice () {
              switch (this.dialog_practice.type) {
                case 0:
                  this.dialog_practice.title = `请选择${this.dialog_practice.text}练习制作方式`
                  this.dialog_practice_list.select = []
                  this.dialog_practice.show = true
                  break
                case 1: {
                  this.dialog_practice.title = `${this.dialog_practice.text}练习修改`
                  this.dialog_practice.practiceId = ''
                  this.dialog_practice.practiceOption = []
                  const option = []

                  this.dialog_practice_list.select = []
                  this.dialog_practice.show = true

                  const wait = await getCourseBindList({
                    id: this.dialog_practice.data.id,
                    model: this.dialog_practice.text === '游戏' ? 'game' : 'customize'
                  })

                  if (this.dialog_practice.text === '游戏') {
                    wait.data.map(val => {
                      val.resources_model && option.push({
                        label: val.resources_model.name,
                        value: val.resources_model.id
                      })
                    })
                  } else {
                    wait.data.map(val => {
                      val.resources_model && option.push({
                        label: val.resources_model.title,
                        value: val.resources_model.id
                      })
                    })
                  }

                  this.dialog_practice.practiceOption = option

                  if (option.length) {
                    this.dialog_practice.practiceId = option[0].value
                  }
                }
                  break
              }
            },

            showPracticeList () {
              this.dialog_practice.show = false
              this.dialog_practice_list.show = true

              if (this.dialog_practice.text === '游戏') {
                this.dialog_practice_list.tableHead = this.dialog_practice_list.gameHead
              } else {
                this.dialog_practice_list.tableHead = this.dialog_practice_list.userHead
              }

              this.getPracticeGameList()
            },

            // 游戏练习制作
            async getPracticeGameList (page = 1) {
              this.dialog_practice_list.loading = true

              let wait

              if (this.dialog_practice.text === '游戏') {
                wait = await getPracticeGame({
                  clients_id: this.$store.state.initConfig.school_id,
                  page,
                  name: this.dialog_practice_list.form.name
                })
              } else {
                wait = await getPracticeList({
                  clients_id: this.$store.state.initConfig.school_id,
                  page,
                  status: 4,
                  title: this.dialog_practice_list.form.title,
                  teacher_name: this.dialog_practice_list.form.teacher_name
                })
              }

              this.dialog_practice_list.data = wait.items
              this.dialog_practice_list.meta = wait.meta
              this.dialog_practice_list.loading = false
            },

            // 游戏练习制作 - 多选
            getPracticeGameSelect (val) {
              this.dialog_practice_list.select = val
            },

            // 游戏练习制作 - 确定绑定
            async getPracticeGameSubmit () {
              if (!this.dialog_practice_list.select.length) {
                this.$message.warning('请先勾选练习')
                return
              }

              const wait = await getCourseOnBind({
                id: this.dialog_practice.data.id,
                clients_id: this.$store.state.initConfig.school_id,
                bind_model: this.dialog_practice.text === '游戏' ? 'game' : 'customize',
                bind_id: this.dialog_practice_list.select.map(val => val.id).join(',')
              })

              if (wait.status_code === 200) {
                this.dialog_practice_list.show = false
                this.$message.success('绑定练习成功')
                this.flashData()
              }
            },

            // 游戏练习制作 取消绑定
            async cancelPracticeBind () {
              if (!this.dialog_practice.practiceId) {
                this.$message.warning('请先选择练习名称')
                return
              }

              const wait = await getCourseOffBind({
                result_id: this.dialog_practice.data.id,
                source: this.dialog_practice.text === '游戏' ? 'game' : 'customize',
                resources_id: this.dialog_practice.practiceId
              })

              if (wait.status_code === 200) {
                this.dialog_practice.show = false
                this.$message.success('取消绑定练习成功')
                this.flashData()
              }
            },

            // 游戏练习制作 - 编辑制作
            showPracticeEdit () {
              if (this.dialog_practice.text === '游戏') {
                window.open(`${Config.imeditMain}?school_id=${this.$store.state.initConfig.school_id}&is_practice=true&id=${this.dialog_practice.data.id}`)
              } else {
                location.href = `${Config.courseware}/main/class/practice/detail?course_id=${this.dialog_practice.data.id}&showFull=true&from=schoolCenter&choolCenterBack=true`
              }

              this.dialog_practice.show = false
            },

            // 游戏练习制作 - 编辑练习
            getPracticeEdit () {
              if (!this.dialog_practice.practiceId) {
                this.$message.warning('请先选择练习名称')
                return
              }

              if (this.dialog_practice.text === '游戏') {
                window.open(`${Config.imeditMain}?school_id=${this.$store.state.initConfig.school_id}&is_practice=true&practice_id=${this.dialog_practice.practiceId}`)
              } else {
                location.href = `${Config.courseware}/main/class/practice/detailLianxik?id=${this.dialog_practice.practiceId}&status=4&course_edit=true&showFull=true&from=schoolCenter&choolCenterBack=true`
              }

              this.dialog_practice.show = false
            },

            // 游戏练习制作 - 预览
            getPracticeDetail (row) {
              const id = row ? row.id : this.dialog_practice.practiceId

              if (!id) {
                this.$message.warning('请先选择练习名称')
                return
              }

              if (this.dialog_practice.text === '游戏') {
                window.open(`${Config.imeditPreview}?school_id=${this.$store.state.initConfig.school_id}&scene=preview&platform=vue&is_practice=true&practice_id=${id}`)
              } else {
                location.href = `${Config.courseware}/main/class/practice/detailLianxik?id=${id}&status=4&course_view=true&showFull=true&from=schoolCenter`
              }
            },
        }
    }
</script>

<style>
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    background: #F0F2F5;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #FF7838;
}
.school-center .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #fed800;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover{
    color: white;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #FF7838;
}
.school-center .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #fed800;
}
.tab-box .el-tabs__nav-wrap::after{
    background-color: white !important;
}
</style>
<style lang="scss" scoped>
.container{
    /*padding: 40px;*/

    .tab-box{
        height: 94px;
        padding: 0px 20px;
        background-color: #F0F2F5;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;

        .tabs{
            position: relative;
            top: 14px;
        }

        /deep/ .el-radio-button__inner{
            border:none;
            background-color: #E4E5E7;
        }
    }
    .list-content{
        background-color: #F0F2F5;
        padding: 0px 20px 20px;
    }
    .pages{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 0px 20px;
        background-color: #f0f2f5;
        padding-bottom: 37px;
    }
    .select-box{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: white;
        padding: 0px 30px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .list-box{
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        overflow-y: auto;
        height: calc(100vh - 335px);
        align-content: flex-start;
        background-color: white;
    }
}
.school-center{
    .list-content{
        background-color: white;

        & > .select-box{
            padding: 0px;
            min-width: 1000px;

            .subject-box{
                margin: 24px 0px 24px;
                margin-left: 12px;

            }
        }
        & > .list-box{
            min-width: 1000px;
        }
    }
    .pages{
        background-color: initial;
        padding-bottom: 0px;
    }
    .list-box{
        height: calc(100vh - 190px);
    }
}
</style>
